// Bootstrap: wire DOM refs into the game context, attach input, and run the main loop.
import { G } from './game/state';
import { resize } from './render/viewport';
import { render } from './render/draw';
import { update } from './game/update';
import { attachPointer } from './input/pointer';
import { camTick } from './input/camera';
import { wireUI } from './ui/screens';
import { preloadSprites } from './assets/sprites';

function init(): void {
  G.canvas = document.getElementById('game') as HTMLCanvasElement;
  G.ctx = G.canvas.getContext('2d')!;
  G.video = document.getElementById('cam') as HTMLVideoElement;
  G.debug = new URLSearchParams(location.search).has('debug');
  if (G.debug) (window as any).__G = G; // dev aid: inspect live game state from the console/tests

  window.addEventListener('resize', resize);
  resize();

  wireUI();
  attachPointer();

  // Preload watercolor sprites in the background; the game falls back to vector art for any
  // that haven't loaded yet, so this never blocks starting a shift.
  void preloadSprites();

  // Force the canvas font face to load up front. Canvas fillText silently falls back to a
  // default serif if 'Ancizar Serif' isn't loaded when it runs, so warm every weight the
  // HUD/floating text/share card use (400/600/700). The render loop picks it up once ready.
  if (document.fonts && document.fonts.load) {
    for (const w of ['400', '600', '700']) void document.fonts.load(`${w} 20px 'Ancizar Serif'`);
  }

  requestAnimationFrame(loop);

  // Register the service worker for offline play (PWA) — production only, so it never caches
  // dev assets / fights HMR. Best-effort; ignored on http/unsupported.
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(import.meta.env.BASE_URL + 'sw.js').catch(() => {
        /* the game still runs online without it */
      });
    });
  }
}

function loop(ts: number): void {
  const raw = (ts - G.last) / 1000 || 0;
  const dt = Math.min(0.05, raw); // physics-clamped
  const dtReal = Math.min(0.5, raw); // wall-clock (mash/finale timers)
  G.last = ts;
  camTick(dt);
  if (G.state === 'play' || G.state === 'finale' || G.state === 'dead' || G.state === 'camwait') update(dt, dtReal);
  render();
  requestAnimationFrame(loop);
}

init();
